/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Sample_RestInputs */

const en_portal_sample_rest = /** @type {(inputs: Portal_Sample_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery`)
};

const pl_portal_sample_rest = /** @type {(inputs: Portal_Sample_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeneracja`)
};

/**
* | output |
* | --- |
* | "Recovery" |
*
* @param {Portal_Sample_RestInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_sample_rest = /** @type {((inputs?: Portal_Sample_RestInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Sample_RestInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_sample_rest(inputs)
	return en_portal_sample_rest(inputs)
});